import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";

import "./RetirementModal.css";

class RetirementModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
    };
  }

  handleClose = () => {
    this.setState({ show: false });
  };

  render() {
    return (
      <Modal
        show={this.state.show}
        onHide={this.handleClose}
        dialogClassName="RetirementModal"
        backdrop="static"
      >
        <Modal.Body>
          <div className="retirement-content">
            <p>
              <strong>Nerds!</strong> It has come to our attention that the site
              is starting to show its age and that maybe its time we put it to
              rest. Due to this, we will no longer be updating setlists here.
            </p>
            <p>
              Have no fear, as the site will stick around in its current form as
              long as we can keep it up and running. You may see it at a new
              domain in the future, but we'll keep you posted when that happens.
            </p>
            <p>
              That being said, we are incredibly excited to announce a new take
              on the site! Please head over to{" "}
              <a href="https://next.spaffnerds.com">next.spaffnerds.com</a> to
              check it out! This is a brand new platform for us, and <strong>will </strong>
              require you go create a new account. Don't worry, we are doing our
              best to make sure your current data is migrated to the new site.
            </p>

            <p className="closing-message">
              Thanks for being part of this community and we hope to see you on
              the new site!
            </p>
            <div>
              <Button
                bsStyle="primary"
                bsSize="large"
                onClick={() =>
                  (window.location.href = "https://next.spaffnerds.com")
                }
              >
                Take me to the future!
              </Button>
            </div>
            <div style={{ marginTop: "12px" }}>
              <Button
                bsStyle="secondary"
                bsSize="medium"
                onClick={this.handleClose}
              >
                Contine to old site
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default RetirementModal;
